/**
 * Black Friday product reviews (sections/bf-product-reviews.liquid): the button opens Loox's own reviews pop-up (the
 * one behind Loox's black side tab, which is hidden on these pages), with photos and "Adaugă o recenzie".
 * When Loox has no side tab on the page, it moves Loox's inline widget (#looxReviews, an iframe the theme cannot
 * style) into the section instead, and shows or hides it. The button stays hidden when the page has no Loox at all.
 */
(function () {
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function setup(root) {
    if (root._bf) return;
    root._bf = true;
    var btn = root.querySelector("[data-bf-loox-open]");
    var panel = root.querySelector("[data-bf-loox-panel]");
    var label = root.querySelector("[data-bf-loox-label]");
    // Loox draws its side tab after the page loads, so it is looked up at click time.
    function sideTab() {
      return document.getElementById("loox-floating-widget-btn");
    }
    if (!btn || !panel || !(document.getElementById("looxReviews") || sideTab())) return;
    btn.hidden = false;

    btn.addEventListener("click", function () {
      var tab = sideTab();
      if (tab) {
        tab.click();
        return;
      }
      var opening = panel.hidden;
      if (opening) {
        var widget = document.getElementById("looxReviews");
        if (widget && widget.parentElement !== panel) panel.appendChild(widget);
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
      btn.setAttribute("aria-expanded", opening ? "true" : "false");
      if (label) label.textContent = opening ? label.dataset.close : label.dataset.open;
      if (opening) panel.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
    });
  }

  // The Loox stars under the product name link to Loox's own widget (#looxReviewsFrame), which is kept out of sight on
  // these pages: they lead to this section instead. Capture phase, so Loox's own scroll does not run.
  document.addEventListener("click", function (e) {
    var star = e.target.closest && e.target.closest('a[href="#looxReviewsFrame"], a[href="#looxReviews"], .loox-rating');
    var section = document.querySelector("[data-bf-product-reviews]");
    if (!star || !section || section.contains(star)) return;
    e.preventDefault();
    e.stopPropagation();
    var title = section.querySelector(".bf-pr__title");
    section.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
    if (title) {
      title.setAttribute("tabindex", "-1");
      title.focus({ preventScroll: true });
    }
  }, true);

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-bf-product-reviews]"), setup);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
